/* Laedt Hintergrundbilder erst kurz bevor sie sichtbar werden und waehlt
   die Bildbreite nach Bildschirm: nie kleiner als heute, oft deutlich kleiner. */
(function () {
  if (window.__jwLazyBgInit) return;
  window.__jwLazyBgInit = true;

  function pick(el) {
    var need = Math.ceil(window.innerWidth * (window.devicePixelRatio || 1));
    var steps = [
      [1000, el.getAttribute('data-bg-small')],
      [1600, el.getAttribute('data-bg-medium')],
      [2400, el.getAttribute('data-bg-large')]
    ];
    for (var i = 0; i < steps.length; i++) {
      if (steps[i][1] && need <= steps[i][0]) return steps[i][1];
    }
    return steps[2][1] || steps[1][1] || steps[0][1];
  }

  function apply(el) {
    if (el.getAttribute('data-bg-done')) return;
    var url = pick(el);
    if (!url) return;
    el.style.backgroundImage = "url('" + url + "')";
    el.setAttribute('data-bg-done', '1');
  }

  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          apply(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '1200px 0px' });
  }

  function scan() {
    var els = document.querySelectorAll('[data-bg-large]:not([data-bg-done])');
    for (var i = 0; i < els.length; i++) {
      if (io) io.observe(els[i]);
      else apply(els[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();
